module.exports = __webpack_public_path__ + "static/media/east_africans_icon_small.bf67b338.png";